var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{attrs:{"disabled":_vm.isFetching,"loading":_vm.isLoading,"type":"success","plain":""},on:{"click":_vm.handleSaveSmartClassifier}},[_vm._v("Save changes")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }